import { useSelector } from 'react-redux';

import { getUserRoles } from '../redux/authority/selectors';

/**
 * Retrieves the user's roles.
 */
export default () => useSelector(getUserRoles);
